














































import { Component, Vue, Mixins } from 'vue-property-decorator';
import { getSheetList } from '@/apis/sheet';
import { Toast } from 'vant';
import sheetCommon from './sheetCommon';
@Component({
	name: 'Sheet',
})
export default class extends Mixins(sheetCommon) {
	private activeName = '';
	private applicationId = '';
	private sheetList = null as any[] | null;
	private get currAppObject() {
		let itemObj = {};
		let arr1 = this.$store.state.app.projectList || [];
		for (let item of arr1) {
			if (item.id + '' === this.applicationId) {
				itemObj = item;
			}
		}
		return itemObj;
	}
	private async fetchData() {
		this.sheetList = null;
		let res = await getSheetList({ id: this.applicationId });
		if (res.code === 200) {
			this.sheetList = (res.data && res.data.worksheetComponents) || [];
		}
	}
	private async clickSheetItem(obj: any) {
		let path;
		switch (obj.componentType) {
			case 'report_worksheet':
				const viewId = await this.searchFilterListReport(obj.id);
				let id;
				if (viewId[0].children && viewId[0].children[0].componentType === 'report_view') {
					id = viewId[0].children[0].id;
				} else {
					id = viewId[0].id;
				}
				path = `/${this.$route.params.applicationId}/${obj.id}/chart/${id}`;
				break;
			case 'worksheet':
				path = `/${this.$route.params.applicationId}/${obj.id}/sheet`;
				break;
			default:
				path = `/home`;
		}
		this.$router.push({ path });
	}
	private mounted() {
		if (this.$route.params && this.$route.params.applicationId) {
			this.applicationId = this.$route.params.applicationId;
			this.fetchData();
		}
	}
}
